import * as React from 'react'
import { useLocation } from 'react-router-dom'

import type { Track } from 'types/track'

import { ContextMenuTarget } from 'components/ds'

import { useExplorerContextMenusEnabled } from 'hooks/use-explorer-context-menus-enabled'

import type { TrackDropdownProps } from '../track-dropdown'
import TrackDropdown from '../track-dropdown'

type Props = Omit<TrackDropdownProps, 'closeMenu' | 'location' | 'track'> & {
  children: React.ReactNode
  track: Track | null | undefined
  /** Leaves the native browser menu in place, for rows with no three-dot menu. */
  disabled?: boolean
}

const noop = () => {}

/**
 * Opens the track's three-dot menu on right-click anywhere in `children`.
 *
 * The menu acts on this track alone, matching the three-dot button, so a
 * right-click deliberately leaves the current multi-selection untouched.
 */
const TrackContextMenu = ({
  children,
  track,
  disabled,
  ...dropdownProps
}: Props): React.ReactNode => {
  const location = useLocation()
  const contextMenusEnabled = useExplorerContextMenusEnabled()

  if (!track || track.tempId) return children

  return (
    <ContextMenuTarget
      disabled={disabled || !contextMenusEnabled}
      menu={
        <TrackDropdown
          {...dropdownProps}
          track={track}
          location={location}
          closeMenu={noop}
        />
      }
    >
      {children}
    </ContextMenuTarget>
  )
}

export default TrackContextMenu
